import React from 'react';
import ReactCountdown from 'react-countdown';

const Countdown = (props) => {
  //! State

  //! Function

  //! Render
  return <ReactCountdown {...props} />;
};

export default React.memo(Countdown);
